import React from "react";
import { Stack } from "..";

import Box from "../Box";
import Typography from "../Typography";

interface ChipsType {
  title: string;
  type:
    | "normal"
    | "primary"
    | "light"
    | "white"
    | "primaryTransparent"
    | "success";
  size?: "small" | "compacted" | "normal";
  textColor?: string;
  action?: React.ReactNode;
}

function Chips(props: ChipsType) {
  let { size = "normal", type, title, action } = props;
  let background;
  let textColor;
  let paddingY;
  let fontSize;
  let fontFamily;
  let borderRadius;

  if (size === "small") {
    borderRadius = "l";
    paddingY = "m";
    fontSize = "s";
    fontFamily = "main";
  } else if (size === "compacted") {
    borderRadius = "l";
    paddingY = "m";
    fontSize = "s";
    fontFamily = "main";
  } else if (size === "normal") {
    paddingY = "xm";
    fontSize = "m";
    fontFamily = "mainBold";
    borderRadius = "xl";
  }
  if (type === "normal") {
    background = "common.white";
    textColor = "common.black";
  } else if (type === "primary") {
    background = "primary.main";
    textColor = "common.white";
  } else if (type === "light") {
    textColor = "primary.main";
    background = "primary.light940";
  } else if (type === "primaryTransparent") {
    textColor = "common.white";
    background = "primary.light980";
  } else if (type === "white") {
    textColor = "primary.main";
    background = "common.white";
  } else if (type === "success") {
    textColor = "common.white";
    background = "green.main";
  }

  return (
    <Box
      br={borderRadius}
      style={{ minWidth: props.size === "small" ? undefined : 100 }}
      px="xm"
      py={paddingY}
      bg={background}
    >
      <Stack distribution={action ? "space-between" : "center"}>
        <Typography
          alignment="center"
          color={props.textColor ? props.textColor : textColor}
          ff={fontFamily}
          fs={fontSize}
        >
          {title ?? "-"}
        </Typography>
        {action ? action : null}
      </Stack>
    </Box>
  );
}

export default Chips;
